import React, { useState, useEffect } from "react";
import "./GroupFilters.scss";
import CustomDatePicker from "components/customDatePicker/CustomDatePicker";
import PropTypes from "prop-types";
import moment from "moment";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { getParameterFromURL } from "services/helper";

function GroupFilters(props) {
  //PROPS
  let { onChangePeriod, onStartDateChange, onEndDateChange, weekAvailable } = {
    ...props,
  };
  //STATE
  const [period, setPeriod] = useState(getSortByFromURL());
  const [endDate, setEndDate] = useState(getEndDateFromURL());
  const [startDate, setStartDate] = useState(getStartDateFromURL());
  //OTHERS
  const isMonth = period === "MONTH";
  const isWeek = period === "WEEK";

  useEffect(() => onChangePeriod && onChangePeriod(period), [period]);

  useEffect(
    () => onStartDateChange && onStartDateChange(startDate),
    [startDate]
  );

  useEffect(() => onEndDateChange && onEndDateChange(endDate), [endDate]);

  useEffect(() => {
    getStartDateFromURL(true);
    getEndDateFromURL(true);
  }, []);

  function getSortByFromURL() {
    const param = getParameterFromURL("period");
    if (param === "DAY" || param === "MONTH" || param === "WEEK") return param;
    return "MONTH";
  }

  function getStartDateFromURL(onlyOnBoot) {
    const param = getParameterFromURL("startDate");
    let date = buildDateFromURL(param);
    let ret = null;

    if (onlyOnBoot && date) {
      if (moment(date).isAfter(endDate)) setEndDate(new Date());
      if (moment(date).isAfter(new Date())) ret = findStartDate();
    } else ret = findStartDate(date);

    if (moment(ret).isAfter(new Date())) ret = findStartDate();
    return ret;
  }

  function getEndDateFromURL() {
    const param = getParameterFromURL("endDate");
    let date = buildDateFromURL(param);
    let ret = findEndDate(date);

    if (date && moment(date).isAfter(new Date())) ret = findEndDate();
    return ret;
  }

  function findStartDate(customDate) {
    if (period === "MONTH") return getMonthFirstDay(customDate || new Date());
    else if (period === "WEEK")
      return getMonday(customDate || new Date()) || customDate;
    else return customDate || new Date();
  }

  function findEndDate(customDate) {
    if (period === "MONTH")
      return getMonthLastDay(customDate || new Date(), true);
    else if (period === "WEEK")
      return getSunday(customDate || new Date()) || customDate;
    else return customDate || new Date();
  }

  function buildDateFromURL(date) {
    if (date) {
      const match = date?.match(/(\d{4})-(\d{2})-(\d{2})/);
      if (match && moment(date).isValid())
        return new Date(date?.replace(/-/g, ","));
    }
    return null;
  }

  function changePeriod(newPeriod) {
    if ((isMonth || isWeek) && newPeriod !== "WEEK") {
      setStartDate(getMonthFirstDay(startDate));
      setEndDate(getMonthLastDay(endDate, true));
    } else if (newPeriod === "WEEK") {
      let monday = getMonday();
      let sunday = getSunday();
      if (monday) setStartDate(monday);
      if (sunday) setEndDate(sunday);
    }
    setPeriod(newPeriod);
  }

  function getMonday(date = startDate) {
    const day = date.getDay();
    const moveBack = day > 0 && day <= 4;
    const isNotMonday = day !== 1;
    if (isNotMonday) {
      let previousMonday = (day + 6) % 7;
      let nextMonday = day === 0 ? 1 : 8 - day;
      let days = moveBack ? -previousMonday : nextMonday;
      let monday = moment(date).add(days, "days");
      const isAfterToday = moment(monday).isAfter(new Date());
      if (isAfterToday) monday = moment(date).add(-previousMonday, "days");
      return new Date(monday.year(), monday.month(), monday.date());
    }
    return null;
  }

  function getSunday(date = endDate) {
    const day = date.getDay();
    const isNotSunday = day !== 0;
    if (isNotSunday) return getNextSunday(date);
    return null;
  }

  function getNextSunday(date) {
    const day = date?.getDay() || new Date().getDay();
    //It's not sunday
    if (day !== 0) {
      const newDate = moment(date || new Date());
      newDate.add(7 - day, "days");
      return new Date(newDate.year(), newDate.month(), newDate.date());
    }
    return date ? date : new Date();
  }

  function getMonthFirstDay(date) {
    if (date) {
      var month = date?.getMonth();
      return new Date(
        date?.getFullYear(),
        month + 1,
        -(getMonthLastDay(date)?.getDate() - 1)
      );
    }
  }

  function getMonthLastDay(date, lastValidDay) {
    if (date) {
      let month = date?.getMonth();
      let lastDay = new Date(date?.getFullYear(), month + 1, 0);
      const isAfter = moment(lastDay).isAfter(new Date());

      if (isAfter && lastValidDay) return new Date();
      else return lastDay;
    }
  }

  function onDateChange(dateType, newDate) {
    const isStartDate = dateType === "startDate";
    if (newDate) {
      let isAfter = null;
      if (isStartDate) {
        isAfter = moment(newDate).isAfter(endDate);
        if (isAfter) setEndDate(new Date());
        setStartDate(newDate);
      } else {
        isAfter = moment(newDate).isAfter(new Date());
        if (isAfter) setEndDate(new Date());
        else setEndDate(newDate);
      }
    } else {
      if (isStartDate) setStartDate(null);
      else setEndDate(null);
    }
  }

  function filterDate(date, allowedDay) {
    if (isWeek) {
      if (allowedDay === "monday") return date?.getDay() === 1;
      else return date?.getDay() === 0;
    }
    return true;
  }

  return (
    <div className="filters-container">
      <div className="date-and-sortby-container">
        <FormControl>
          <InputLabel>Período</InputLabel>
          <Select
            native
            id="grouped-native-select"
            label="Grouping"
            value={period}
            onChange={(event) => changePeriod(event.target.value)}
            size="small"
          >
            <option value={"DAY"}>Dia</option>
            {weekAvailable && <option value={"WEEK"}>Semana</option>}
            <option value={"MONTH"}>Mês</option>
          </Select>
        </FormControl>

        <div className="datepicker-container">
          <span className="date-label">De</span>
          <CustomDatePicker
            value={startDate}
            maxDate={new Date()}
            dateFormat={isMonth ? "MM/yyyy" : "dd/MM/yyyy"}
            showMonthYearPicker={isMonth ? true : false}
            filterDate={(date) => filterDate(date, "monday")}
            onChange={(newStartDate) =>
              onDateChange(
                "startDate",
                isMonth ? getMonthFirstDay(newStartDate) : newStartDate
              )
            }
          />
        </div>
        <div className="datepicker-container">
          <span className="date-label">Até</span>
          <CustomDatePicker
            value={endDate}
            minDate={startDate}
            maxDate={
              isMonth
                ? getMonthLastDay(new Date())
                : isWeek
                ? getNextSunday()
                : new Date()
            }
            dateFormat={isMonth ? "MM/yyyy" : "dd/MM/yyyy"}
            showMonthYearPicker={isMonth ? true : false}
            filterDate={(date) => filterDate(date, "sunday")}
            onChange={(newEndDate) =>
              onDateChange(
                "endDate",
                isMonth ? getMonthLastDay(newEndDate) : newEndDate
              )
            }
          />
        </div>
      </div>
    </div>
  );
}

export default GroupFilters;

GroupFilters.defaultProps = {
  onChangePeriod: null,
  onStartDateChange: null,
  onEndDateChange: null,
  onGroupChange: null,
  selectedGroup: null,
  setSelectedGroup: null,
  onGroupSelectorRequestFinally: null,
  groupType: "migration",
};

GroupFilters.propTypes = {
  onChangePeriod: PropTypes.func,
  onStartDateChange: PropTypes.func,
  onEndDateChange: PropTypes.func,
  onGroupChange: PropTypes.func,
  selectedGroup: PropTypes.object,
  setSelectedGroup: PropTypes.func,
  onGroupSelectorRequestFinally: PropTypes.func,
  groupType: PropTypes.string,
};
